import { withStyles } from '@material-ui/core/styles';

export function WithStyles(styles: Parameters<typeof withStyles>[0], options?: Parameters<typeof withStyles>[1]) {
  return function<T>(target: T): T {
    return withStyles(styles, options || {})(target as any) as any;
  };
}
